
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41 41"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 40.5a20 20 0 10-20-20 20 20 0 0020 20zM9.652 20.067l19.283-7.435c.9-.323 1.677.218 1.387 1.572h0L27.04 29.67c-.243 1.1-.895 1.363-1.807.847l-5-3.685-2.412 2.323a1.261 1.261 0 01-1.008.492l.355-5.088 9.267-8.372c.4-.355-.09-.555-.622-.2L14.362 23.2l-4.937-1.54c-1.072-.34-1.1-1.072.227-1.588z","fill":"none","stroke":"#707070"}})])
          )
        }
      }
    